import {MemberProgramType} from './member-program-type.model';
import {EarningType} from './earning-type.model';
export class MemberProgram {
  type: MemberProgramType;
  earningPreference: EarningType;
  constructor(type: MemberProgramType, earningPreference?: EarningType) {
    this.type = type;
    this.earningPreference = earningPreference;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/member-program.model.ts